<ngx-loading [show]="showSpinner"></ngx-loading>

<div class="card page-content">
    <div class="row justify-content-center">
        <div class="col-md-12">
            <div class="card">

                <!-- Header con avatar -->
                <div class="modal-header align-items-center">
                    <div class="d-flex align-items-center">
                        <div class="user-avatar mr-3">{{ initials }}</div>
                        <div>
                            <p class="modal-title mb-0 font-weight-500">{{ userInvite?.fullName }}</p>
                            <p class="text-muted small mb-0">{{ translate.instant(userInvite?.role) }}</p>
                        </div>
                    </div>
                    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <!-- Sección info (grid 2 columnas) -->
                <div class="modal-body border-top pt-4">
                    <div class="row">
                        <div class="col-6 mb-3">
                            <p class="detail-label">{{'usersModule.firstAndLastName' | translate}}</p>
                            <p class="detail-value mb-0">{{ userInvite?.fullName }}</p>
                        </div>
                        <div class="col-6 mb-3">
                            <p class="detail-label">{{'usersModule.email' | translate}}</p>
                            <p class="detail-value mb-0">{{ userInvite?.email }}</p>
                        </div>
                        <div class="col-6">
                            <p class="detail-label">{{'usersModule.role' | translate}}</p>
                            <p class="detail-value mb-0">{{ translate.instant(userInvite?.role) }}</p>
                        </div>
                        <div class="col-6">
                            <p class="detail-label">{{'usersModule.status' | translate}}</p>
                            <span class="badge" [ngClass]="statusBadgeClass">
                                {{ translate.instant(userInvite?.currentStatus) }}
                            </span>
                        </div>
                    </div>
                </div>

                <!-- Toggle: Acceso al sistema -->
                <div class="modal-body border-top pt-3" *ngIf="canBlockUnblock">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <p class="mb-1 font-weight-500 small">{{'usersModule.systemAccess' | translate}}</p>
                            <p class="text-muted small mb-0">Permite o bloquea el acceso del usuario</p>
                        </div>
                        <div class="custom-control custom-switch"
                             [title]="isBlocked ? translate.instant('usersModule.unBlockUserTitle') : translate.instant('usersModule.blockUserTitle')"
                             (click)="blockUnblockUser()">
                            <input type="checkbox" class="custom-control-input" id="switchDetail"
                                   [checked]="isRegistered"
                                   disabled />
                            <label class="custom-control-label cursor-pointer" for="switchDetail"></label>
                        </div>
                    </div>
                </div>

                <!-- Toggle: Credencial activa -->
                <div class="modal-body border-top pt-3" *ngIf="isRegistered || isRevoked">
                    <div class="d-flex align-items-center justify-content-between">
                        <div>
                            <p class="mb-1 font-weight-500 small">Credencial activa</p>
                            <p class="text-muted small mb-0">Revoca o reactiva la credencial verificable</p>
                        </div>
                        <div class="custom-control custom-switch" (click)="toggleCredential()">
                            <input type="checkbox" class="custom-control-input" id="switchCredential"
                                   [checked]="isRegistered"
                                   disabled />
                            <label class="custom-control-label cursor-pointer" for="switchCredential"></label>
                        </div>
                    </div>

                    <!-- Formulario de revocación (aparece al desactivar el toggle) -->
                    <div *ngIf="showRevokeForm" class="mt-3">
                        <p class="text-danger small font-weight-bold">
                            Esta acción bloqueará el acceso del usuario a la plataforma.
                        </p>
                        <div class="form-group mb-2">
                            <label class="form-control-label text-uppercase small">Motivo de revocación</label>
                            <div *ngFor="let r of revocationReasonLabels" class="form-check">
                                <input class="form-check-input" type="radio" [value]="r.value"
                                    [(ngModel)]="selectedReason" [name]="'reason'" [id]="'reason_' + r.value">
                                <label class="form-check-label small" [for]="'reason_' + r.value">{{ r.label }}</label>
                            </div>
                        </div>
                        <div class="form-group mb-2" *ngIf="selectedReason === revocationReason.Otro">
                            <label class="form-control-label text-uppercase small">Descripción (obligatorio)</label>
                            <textarea class="form-control form-control-sm" rows="2" [(ngModel)]="reasonText"
                                placeholder="Ingresá el motivo..."></textarea>
                        </div>
                        <div class="d-flex mt-2">
                            <button class="btn btn-sm btn-danger mr-2" (click)="confirmRevoke()" [disabled]="!canConfirmRevoke">
                                Confirmar revocación
                            </button>
                            <button class="btn btn-sm btn-outline-secondary" (click)="cancelRevoke()">
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>

                <!-- Footer -->
                <div class="modal-footer mt-3">
                    <button class="btn btn-outline-secondary btn-sm" (click)="closeModal()">
                        {{'close' | translate}}
                    </button>
                </div>

            </div>
        </div>
    </div>
</div>
